import React from "react";
import { observer } from "mobx-react-lite";
import { IAssessment } from "../../../../Models/Assessment";
import { IRecipientModel } from "../../../../Models/Recipient";
import TaskInformationStep from "../../../Assessment/TaskInformationStep";
import ModalQuestionBox from "./ModuleModal/ModalQuestionBox";

interface TaskCompleterProps {
  topContentRef: React.RefObject<HTMLDivElement>;
  questionContentRef: React.RefObject<HTMLDivElement>;
  task: IAssessment;
  returnToOverview: () => void;
  showTaskList: () => void;
  selectedRecipient: IRecipientModel;
  taskIndex: number;
  infoSlideIndex: number;
  domain: string;
  nextTaskHandler: () => void;
}

const TaskCompleter: React.FC<TaskCompleterProps> = (props) => {
  const { task, infoSlideIndex, domain, nextTaskHandler, topContentRef, questionContentRef } =
    props;


  return (
    <>
      <TaskInformationStep
        topContentRef={topContentRef}
        slideKey={task.infoSlideKeys[infoSlideIndex]}
        domain={domain}
        questionCompleter={<ModalQuestionBox
          assessment={task}
          slideIndex={infoSlideIndex}
          nextTaskHandler={nextTaskHandler}
          questionContentRef={questionContentRef}
        />}
      />      
    </>
  );
};

export default observer(TaskCompleter);
